<div class="row cl-spacing-small" [formGroup]="form">
  <div class="col-12 col-md-3 cl-spacing-tiny">
    <label for="audio" class="form-label">Audio Languages</label>
    <div>
      <app-language-select id="audio" formControlName="audio"></app-language-select>
    </div>
  </div>
  <div class="col-12 col-md-3 cl-spacing-tiny">
    <label for="subtitles" class="form-label">Subtitle Languages</label>
    <div>
      <app-language-select id="subtitles" formControlName="subtitles"></app-language-select>
    </div>
  </div>
  <div class="col-12 col-md-3 cl-spacing-tiny">
    <label for="cc" class="form-label">Closed Captions Languages</label>
    <div>
      <app-language-select id="cc" formControlName="cc"></app-language-select>
    </div>
  </div>
  @if (burnInSupported) {
    <div class="col-12 col-md-3 cl-spacing-tiny">
      <label for="burntin" class="form-label">Burnt-in</label>
      <div>
        <select id="burntin" formControlName="burntin" class="form-select">
          <option [ngValue]="null">None</option>
          @for (opt of burntinOptions; track opt) {
            <option [ngValue]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>
    </div>
  }
  @if (burnInSupported && form.controls['titlecard'].value) {
    <div class="col-12 cl-spacing-tiny">
      <label for="titlecard_text" class="form-label">Title card text</label>
      <input id="titlecard_text" type="text" class="form-control" formControlName="titlecard_text"
             [maxlength]="titlecardMaxLength" [class.invalid]="form.controls['titlecard_text'].invalid">
      @if (form.controls['titlecard_text'].invalid) {
        <p class="invalid-feedback">Enter the text to burn in, at most {{ titlecardMaxLength }} characters.</p>
      } @else {
        <p class="form-text valid-feedback">Text to be displayed.</p>
      }
    </div>
  }
</div>
